import { useEffect, useState, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BG_IMG from "../images/AMCP_APP_LP_OTT_F.jpg";
import { checkSignUpData, checkSignInData } from "../utils/formVaildate";
const Login = () => {
  const [isSignInForm, setIsSignInForm] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const fullName = useRef(null);
  const email = useRef(null);
  const password = useRef(null);

  //Title i.e Browser Tab
  useEffect(() => {
    document.title = "Sign In";
    return () => {
      document.title = "aimax";
    };
  });

  const toggleSignInForm = () => {
    setIsSignInForm(!isSignInForm);
  };

  const handleBtnClick = () => {
    const validateMessage = isSignInForm
      ? checkSignInData(email.current.value, password.current.value)
      : checkSignUpData(
          fullName.current.value,
          email.current.value,
          password.current.value
        );

    setErrorMessage(validateMessage);
  };



  return (
    <div className="relative">
      <Header />
      <div className="absolute">
        <img src={BG_IMG} alt="" className="object-cover min-h-screen" />
      </div>
      <form
        className="w-4/12 absolute  p-12  left-10 right-0 mt-28 text-white rounded-lg bg-opacity-80 "
        onSubmit={(e) => e.preventDefault()} //to prevent reloading cuz of form submit
      >
        <h1 className="my-2 text-3xl font-bold">
          {isSignInForm ? "Sign In" : "Sign Up"}
        </h1>

        {!isSignInForm && (
          <div className="my-4">
            <label htmlFor="fullName" className="text-xl">
              Full Name
            </label>
            <input
              type="text"
              id="fullName"
              ref={fullName}
              className="px-4 py-3 my-1 w-full bg-[#0e0d26] placeholder-white rounded-xl text-xl border border-white focus:outline-none"
            />
          </div>
        )}

        <div className="my-4">
          <label htmlFor="email" className="text-xl">
            Email address
          </label>
          <input
            type="text"
            id="email"
            ref={email}
            className="px-4 py-3 my-1 w-full bg-[#0e0d26] placeholder-white rounded-xl text-xl border border-white focus:outline-none"
          />
        </div>
        <div className="my-4">
          <label htmlFor="password" className="text-xl">
            Password
          </label>
          <input
            type="password"
            ref={password}
            id="password"
            className="px-4 py-3 my-1 w-full bg-[#0e0d26] placeholder-white rounded-xl text-xl border border-white focus:outline-none"
          />
        </div>

        {
          //Erro Message
          errorMessage === null ? (
            ""
          ) : (
            <p className="text-red-600 rounded-xl p-2 bg-[#361828]">
              {errorMessage}
            </p>
          )
        }

        <button
          className="w-2/5 px-10 py-2 my-4 font-bold bg-white text-[#060730] rounded-lg text-xl"
          onClick={handleBtnClick}
        >
          {isSignInForm ? "Sign In" : "Sign Up"}
        </button>

        <div>
          <span className="text-md text-gray-400">
            {isSignInForm ? "New to " : "Already a "}
          </span>
          <span className="text-xl font-bold text-gray-400">
            {" "}
            {isSignInForm ? "aimax? " : "user? "}
          </span>
          <span
            className="text-xl cursor-pointer hover:border-b"
            onClick={toggleSignInForm}
          >
            {isSignInForm ? "Sign Up Now" : "Sign In"}
          </span>
        </div>
      </form>
      {/* <Footer className=" " /> */}
    </div>
  );
};

export default Login;
